<template>
  <main class="ws">

<!-- ============ 首屏 ============ -->
<section class="ph ph--ink ph--center">
  <div class="wrap">
    <span class="ph__kicker">{{ $t("平台功能") }}</span>
    <h1 class="ph__title">{{ $t("开店要用的东西，这一页全有") }}</h1>
    <p class="ph__sub">{{ $t("建站、翻译、上架、发货、收款、拉客户——") }}<b>{{ $t("15 个模块都在一个后台") }}</b>{{ $t("，不用再去外面拼七八个工具，也不用为了一个功能换一次服务商。") }}</p>
    <div class="btns" style="justify-content:center">
      <router-link class="btn btn--primary" to="/sign-up">{{ $t("免费开店，10 分钟看到你的店") }}</router-link>
      <a class="btn btn--line" href="#modules">{{ $t("先看有哪些模块") }}</a>
    </div>
    <p class="ph__meta">
      <i><svg class="ico"><use href="#i-check"/></svg>{{ $t("15 个内置模块") }}</i>
      <i><svg class="ico"><use href="#i-globe"/></svg>{{ $t("20 种语言") }}</i>
      <i><svg class="ico"><use href="#i-percent"/></svg>{{ $t("佣金 3% 起") }}</i>
    </p>


  </div>
</section>

<div class="guide-band guide-band--after-ink">
  <div class="wrap">
<div class="guide guide--center">
      <img class="guide__m" src="/website/img/tao-hi.png" alt="">
      <div class="bubble">{{ $t("第一次开店最怕的是“还差一样东西”。我把常用的都摆在这一页了，") }}<b>{{ $t("从上往下看就行") }}</b>{{ $t("。") }}</div>
    </div>
  </div>
</div>

<!-- ============ 数据 ============ -->
<section class="sec sec--tight">
  <div class="wrap">
    <div class="metrics">
      <div class="metric"><b>15</b><span>{{ $t("内置模块，一个后台") }}</span></div>
      <div class="metric"><b>20</b><span>{{ $t("种语言，覆盖全球买家") }}</span></div>
      <div class="metric"><b>5</b><span>{{ $t("获客渠道可自动投放") }}</span></div>
      <div class="metric"><b>3–6<em>%</em></b><span>{{ $t("交易佣金阶梯") }}</span></div>
    </div>
  </div>
</section>

<!-- ============ 模块总览 ============ -->
<section class="sec sec--gray" id="modules">
  <div class="wrap">
    <div class="sec__head">
      <span class="eyebrow">{{ $t("模块总览") }}</span>
      <h2 class="sec__title">{{ $t("八个方向，撑起一间店") }}</h2>
      <p class="sec__sub">{{ $t("每个方向下面都有几个具体功能，往下翻能看到怎么用。") }}</p>
    </div>

    <div class="grid4">
      <article class="card">
        <span class="ico-badge"><svg class="ico"><use href="#i-palette"/></svg></span>
        <h3 class="card__t">{{ $t("建站与装修") }}</h3>
        <p class="card__d">{{ $t("选模板、拖组件，改完立刻生效。") }}</p>
        <ul class="card__list"><li>{{ $t("6 套主题") }}</li><li>{{ $t("手机端自动适配") }}</li></ul>
      </article>
      <article class="card">
        <span class="ico-badge"><svg class="ico"><use href="#i-globe"/></svg></span>
        <h3 class="card__t">{{ $t("20 种语言") }}</h3>
        <p class="card__d">{{ $t("20 种语言一次配好，买家进来就是他的母语。") }}</p>
        <ul class="card__list"><li>{{ $t("自动翻译") }}</li><li>{{ $t("可人工改") }}</li></ul>
      </article>
      <article class="card">
        <span class="ico-badge"><svg class="ico"><use href="#i-box"/></svg></span>
        <h3 class="card__t">{{ $t("商品与供应链") }}</h3>
        <p class="card__d">{{ $t("粘个链接就能上架，卖出去再采购。") }}</p>
        <ul class="card__list"><li>{{ $t("1688 / 淘宝采集") }}</li><li>{{ $t("库存同步") }}</li></ul>
      </article>
      <article class="card">
        <span class="ico-badge"><svg class="ico"><use href="#i-sparkle"/></svg></span>
        <h3 class="card__t">{{ $t("AI 员工") }}</h3>
        <p class="card__d">{{ $t("客服、标题、描述，都能交给它。") }}</p>
        <ul class="card__list"><li>{{ $t("24 小时在线") }}</li><li>{{ $t("多语言回复") }}</li></ul>
      </article>
      <article class="card">
        <span class="ico-badge"><svg class="ico"><use href="#i-horn"/></svg></span>
        <h3 class="card__t">{{ $t("AI 营销") }}</h3>
        <p class="card__d">{{ $t("诊断店铺，给 30 天计划，自动发帖。") }}</p>
        <ul class="card__list"><li>{{ $t("5 个渠道") }}</li><li>{{ $t("内容日历") }}</li></ul>
      </article>
      <article class="card">
        <span class="ico-badge"><svg class="ico"><use href="#i-link"/></svg></span>
        <h3 class="card__t">{{ $t("代购与集运") }}</h3>
        <p class="card__d">{{ $t("客户付外币，平台代买代发。") }}</p>
        <ul class="card__list"><li>{{ $t("外币收款") }}</li><li>{{ $t("合箱省运费") }}</li></ul>
      </article>
      <article class="card">
        <span class="ico-badge"><svg class="ico"><use href="#i-truck"/></svg></span>
        <h3 class="card__t">{{ $t("订单与物流") }}</h3>
        <p class="card__d">{{ $t("批量打面单，轨迹一处看完。") }}</p>
        <ul class="card__list"><li>{{ $t("云途 / 燕文 / 4PX") }}</li><li>{{ $t("异常提醒") }}</li></ul>
      </article>
      <article class="card">
        <span class="ico-badge"><svg class="ico"><use href="#i-wallet"/></svg></span>
        <h3 class="card__t">{{ $t("收款与结算") }}</h3>
        <p class="card__d">{{ $t("PayPal、Stripe、支付宝接上即用。") }}</p>
        <ul class="card__list"><li>{{ $t("T+7 结算") }}</li><li>{{ $t("多币种提现") }}</li></ul>
      </article>
    </div>
  </div>
</section>

<!-- ============ 01 建站 ============ -->
<section class="sec">
  <div class="wrap">
    <div class="frow">
      <div>
        <span class="frow__tag">{{ $t("01 · 建站") }}</span>
        <h2 class="frow__t">{{ $t("不用会代码，也能把店弄得像样") }}</h2>
        <p class="frow__d">{{ $t("选一套模板，改文字和图片，手机上就是成品。想调结构就拖组件——左边挑、中间摆，改完点保存，前台立刻变。") }}</p>
        <ul class="frow__list">
          <li><svg class="ico"><use href="#i-check"/></svg><span>{{ $t("首页、商品页、文章页都能可视化编辑") }}</span></li>
          <li><svg class="ico"><use href="#i-check"/></svg><span>{{ $t("手机和桌面两套排版分开调，不用互相将就") }}</span></li>
          <li><svg class="ico"><use href="#i-check"/></svg><span>{{ $t("改坏了能撤回上一版，不怕点错") }}</span></li>
        </ul>
      </div>
      <div class="frow__media">
        <div class="media-card">
          <div class="ed">
            <div class="ed__bar"><i></i><i></i><i></i><span>{{ $t("编辑 · 首页") }}</span></div>
            <div class="ed__body">
              <div class="ed__side">
                <b>{{ $t("组件") }}</b>
                <span>{{ $t("标题") }}</span>
                <span class="on">{{ $t("商品列表") }}</span>
                <span>{{ $t("图片") }}</span>
                <span>{{ $t("优惠券") }}</span>
                <span>{{ $t("视频") }}</span>
                <span>{{ $t("评价") }}</span>
              </div>
              <div class="ed__canvas">
                <div class="ed__block">{{ $t("主视觉 banner") }}<em>{{ $t("拖动") }}</em></div>
                <div class="ed__block ed__block--on">{{ $t("四列商品") }}<em>{{ $t("选中") }}</em></div>
                <div class="ed__block">{{ $t("买家评价") }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ============ 02 语言 ============ -->
<section class="sec sec--gray">
  <div class="wrap">
    <div class="frow frow--flip">
      <div>
        <span class="frow__tag">{{ $t("02 · 多语言") }}</span>
        <h2 class="frow__t">{{ $t("20 种语言，一次上完") }}</h2>
        <p class="frow__d">{{ $t("后台的语言列表和店铺前台是同一套，开一个语言，商品标题、描述、政策页都会自动翻。翻得不顺手的句子，可以自己改，改完只影响这一句。") }}</p>
        <ul class="frow__list">
          <li><svg class="ico"><use href="#i-check"/></svg><span>{{ $t("英、日、韩、德、法、西、葡、意、俄、阿……共 20 种") }}</span></li>
          <li><svg class="ico"><use href="#i-check"/></svg><span>{{ $t("机翻打底 + 人工修正，术语不会被翻歪") }}</span></li>
          <li><svg class="ico"><use href="#i-check"/></svg><span>{{ $t("每种语言有独立的标题和描述，搜索结果不打架") }}</span></li>
        </ul>
      </div>
      <div class="frow__media">
        <div class="media-card">
          <div class="langwall">
            <span class="on">{{ $t("中文") }}</span><span>English</span><span>{{ $t("繁體中文") }}</span><span>{{ $t("日本語") }}</span>
            <span>한국어</span><span>Deutsch</span><span>Français</span><span>Español</span>
            <span>Português</span><span>Italiano</span><span>Русский</span><span>العربية</span>
            <span>Türkçe</span><span>Tiếng Việt</span><span>ไทย</span><span>Indonesia</span>
            <span>Melayu</span><span>Қазақша</span><span>မြန်မာ</span><span>ລາວ</span>
          </div>
          <div class="note" style="margin-top:14px">
            <svg class="ico"><use href="#i-globe"/></svg>
            <span>{{ $t("店里开的每个语言都在这个列表里，") }}<b>{{ $t("两边一一对应") }}</b>{{ $t("，不会出现后台开了前台没有的情况。") }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ============ 03 商品 ============ -->
<section class="sec">
  <div class="wrap">
    <div class="frow">
      <div>
        <span class="frow__tag">{{ $t("03 · 商品") }}</span>
        <h2 class="frow__t">{{ $t("选品不用来回切十个网站") }}</h2>
        <p class="frow__d">{{ $t("从 1688、淘宝粘个链接，商品就采到自己店里，价格、规格、图片一起过来。卖出去再去采购，不用先压一批货在仓库。") }}</p>
        <ul class="frow__list">
          <li><svg class="ico"><use href="#i-check"/></svg><span>{{ $t("采集后自动换成店铺币种，加价规则自己定") }}</span></li>
          <li><svg class="ico"><use href="#i-check"/></svg><span>{{ $t("库存和价格变动会同步，减少超卖") }}</span></li>
          <li><svg class="ico"><use href="#i-check"/></svg><span>{{ $t("支持一件代发，也可以批量导出到自己的仓") }}</span></li>
        </ul>
      </div>
      <div class="frow__media">
        <div class="media-card">
          <div class="tbl-wrap" style="border-radius:12px">
            <table class="tbl" style="min-width:0">
              <thead><tr><th>{{ $t("商品") }}</th><th style="text-align:right">{{ $t("采购价") }}</th><th style="text-align:right">{{ $t("店铺售价") }}</th><th style="text-align:right">{{ $t("库存") }}</th></tr></thead>
              <tbody>
                <tr><td>{{ $t("纯棉圆领 T 恤") }}</td><td class="num">¥18</td><td class="num">$16.90</td><td class="num">236</td></tr>
                <tr><td>{{ $t("帆布托特包") }}</td><td class="num">¥26</td><td class="num">$24.50</td><td class="num">88</td></tr>
                <tr><td>{{ $t("无线蓝牙耳机") }}</td><td class="num">¥63</td><td class="num">$59.00</td><td class="num">41</td></tr>
                <tr><td>{{ $t("极简石英手表") }}</td><td class="num">¥72</td><td class="num">$66.00</td><td class="num">12</td></tr>
              </tbody>
            </table>
          </div>
          <div class="note" style="margin-top:14px">
            <svg class="ico"><use href="#i-refresh"/></svg>
            <span>{{ $t("显示的是") }}<b>{{ $t("你的进价和你的售价") }}</b>{{ $t("，中间差多少，一眼看得清。") }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ============ 04 AI 员工 ============ -->
<section class="sec sec--gray">
  <div class="wrap">
    <div class="frow frow--flip">
      <div>
        <span class="frow__tag">{{ $t("04 · AI 员工") }}</span>
        <h2 class="frow__t">{{ $t("半夜的询盘，也有人回") }}</h2>
        <p class="frow__d">{{ $t("客户问发货要几天、尺码怎么选、能不能退——AI 员工按你定的规则答，答不了的转人工。写标题、翻描述、改商品图，也能一起交给它。") }}</p>
        <ul class="frow__list">
          <li><svg class="ico"><use href="#i-check"/></svg><span>{{ $t("24 小时在线，时差不用你熬夜补") }}</span></li>
          <li><svg class="ico"><use href="#i-check"/></svg><span>{{ $t("用你的语气和退换规则，不乱承诺") }}</span></li>
          <li><svg class="ico"><use href="#i-check"/></svg><span>{{ $t("中英日韩等语言来回切，客户说什么它听什么") }}</span></li>
        </ul>
      </div>
      <div class="frow__media">
        <div class="media-card">
          <div class="chat">
            <div class="chat__row chat__row--in">
              <span class="chat__who">{{ $t("买家 · 02:14") }}</span>
              <p class="chat__msg">Hi, does this ship to Germany? How long does it take?</p>
            </div>
            <div class="chat__row chat__row--out">
              <span class="chat__who">{{ $t("AI 员工 · 02:14") }}</span>
              <p class="chat__msg">Yes — Germany, 6–9 business days, tracked all the way. Free shipping over $49.</p>
            </div>
            <div class="chat__tag">{{ $t("已自动回复 · 用时 3 秒") }}</div>
            <div class="chat__row chat__row--in">
              <span class="chat__who">{{ $t("买家 · 02:15") }}</span>
              <p class="chat__msg">What if the size doesn't fit?</p>
            </div>
            <div class="chat__row chat__row--out">
              <span class="chat__who">{{ $t("转人工 · 02:15") }}</span>
              <p class="chat__msg">{{ $t("退换属于承诺类问题，已转给你，附上了订单号。") }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ============ 05 AI 营销 ============ -->
<section class="sec" id="growth">
  <div class="wrap">
    <div class="frow">
      <div>
        <span class="frow__tag">{{ $t("05 · AI 营销") }}</span>
        <h2 class="frow__t">{{ $t("不会投广告，也能让客户找上门") }}</h2>
        <p class="frow__d">{{ $t("接上豆包这类 AI，先诊断你的店哪里不对劲，再给一份 30 天能照着做的内容和投放计划。Facebook、Instagram、TikTok 的帖子可以自动生成、定时发。") }}</p>
        <ul class="frow__list">
          <li><svg class="ico"><use href="#i-check"/></svg><span>{{ $t("店铺诊断：标题、图片、价格、转化，逐项说问题") }}</span></li>
          <li><svg class="ico"><use href="#i-check"/></svg><span>{{ $t("30 天内容日历，哪天发什么直接排好") }}</span></li>
          <li><svg class="ico"><use href="#i-check"/></svg><span>{{ $t("一件商品铺到 9 个渠道，博客和邮件能自动发") }}</span></li>
        </ul>
        <div class="note" style="margin-top:20px">
          <svg class="ico"><use href="#i-chat"/></svg>
          <span>{{ $t("AI 给的是初稿。") }}<b>{{ $t("涉及价格和承诺的内容，建议人工过一眼再发") }}</b>{{ $t("，这一步我们不会替你做主。") }}</span>
        </div>
        <p style="margin-top:18px"><router-link class="link-arrow" to="/ai-staff">{{ $t("看 18 位 AI 员工的分工") }} <i>→</i></router-link></p>
      </div>
      <div class="frow__media">
        <div class="media-card">
          <div class="steps">
            <div class="step">
              <span class="step__n">1</span>
              <div><div class="step__t">{{ $t("诊断你的店") }}</div><div class="step__d">{{ $t("抓取首页和 20 个商品页，找出转化流失的位置。") }}</div></div>
            </div>
            <div class="step">
              <span class="step__n">2</span>
              <div><div class="step__t">{{ $t("给出 30 天计划") }}</div><div class="step__d">{{ $t("每天发什么、配什么图、投多少预算，写成清单。") }}</div></div>
            </div>
            <div class="step">
              <span class="step__n">3</span>
              <div><div class="step__t">{{ $t("九个渠道一次铺完") }}</div><div class="step__d">{{ $t("Pinterest、IG、FB、X、TikTok、WhatsApp、Telegram、Google 商家、站内博客。") }}</div></div>
            </div>
            <div class="step">
              <span class="step__n">4</span>
              <div><div class="step__t">{{ $t("每周回收数据") }}</div><div class="step__d">{{ $t("哪些帖子带来点击，下一周把预算挪过去。") }}</div></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ============ 06 代购与 BuyLink ============ -->
<section class="sec sec--gray" id="buylink">
  <div class="wrap">
    <div class="frow frow--flip">
      <div>
        <span class="frow__tag">{{ $t("06 · 代购 / BuyLink") }}</span>
        <h2 class="frow__t">{{ $t("客户付外币，你只发国内快递") }}</h2>
        <p class="frow__d">{{ $t("客户在你店里看到的是外币价，点「代购下单」跳到平台，链接已经预填好。平台买手替你采购、合箱、出国际单。你负责把货送到国内仓，剩下的跨境段平台接走。") }}</p>
        <ul class="frow__list">
          <li><svg class="ico"><use href="#i-check"/></svg><span>{{ $t("收外币、付人民币，中间不用自己换汇") }}</span></li>
          <li><svg class="ico"><use href="#i-check"/></svg><span>{{ $t("多件合箱，运费比一件一件发便宜") }}</span></li>
          <li><svg class="ico"><use href="#i-check"/></svg><span>{{ $t("国际段轨迹可查，客户催单时有话说") }}</span></li>
        </ul>
        <router-link class="frow__link" to="/logistics">{{ $t("看跨境物流怎么走") }}<svg class="ico"><use href="#i-arrow"/></svg></router-link>
      </div>
      <div class="frow__media">
        <div class="media-card">
          <div class="steps">
            <div class="step">
              <span class="step__n">1</span>
              <div><div class="step__t">{{ $t("客户在你的店下单") }}</div><div class="step__d">{{ $t("看到的是你的价格、你的币种、你的品牌。") }}</div></div>
            </div>
            <div class="step">
              <span class="step__n">2</span>
              <div><div class="step__t">{{ $t("点「代购下单」") }}</div><div class="step__d">{{ $t("跳到平台，商品链接和规格已预填，客户只需确认。") }}</div></div>
            </div>
            <div class="step">
              <span class="step__n">3</span>
              <div><div class="step__t">{{ $t("平台采购并合箱") }}</div><div class="step__d">{{ $t("买手收货、验货、去掉多余包装，几单并一箱。") }}</div></div>
            </div>
            <div class="step">
              <span class="step__n">4</span>
              <div><div class="step__t">{{ $t("出国际单，轨迹回传") }}</div><div class="step__d">{{ $t("单号自动回到你的订单里，客户也能看到。") }}</div></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ============ 07 订单与客户 ============ -->
<section class="sec">
  <div class="wrap">
    <div class="sec__head">
      <span class="eyebrow">{{ $t("后台日常") }}</span>
      <h2 class="sec__title">{{ $t("订单、客户、权限，一个地方管完") }}</h2>
      <p class="sec__sub">{{ $t("店里跑起来以后，每天真正要看的就这三块。") }}</p>
    </div>

    <div class="grid3">
      <article class="card">
        <span class="ico-badge ico-badge--sm"><svg class="ico"><use href="#i-chart"/></svg></span>
        <h3 class="card__t">{{ $t("订单看板") }}</h3>
        <p class="card__d">{{ $t("今天几单、待发货几单、哪单卡在海关，打开就看见。") }}</p>
        <ul class="card__list"><li>{{ $t("批量打面单，一次几十张") }}</li><li>{{ $t("异常件单独列出来") }}</li></ul>
      </article>
      <article class="card">
        <span class="ico-badge ico-badge--sm"><svg class="ico"><use href="#i-user"/></svg></span>
        <h3 class="card__t">{{ $t("客户资产") }}</h3>
        <p class="card__d">{{ $t("邮箱、订单、复购记录都在你的后台，不是平台的。") }}</p>
        <ul class="card__list"><li>{{ $t("一键导出 CSV") }}</li><li>{{ $t("按购买次数分组") }}</li></ul>
      </article>
      <article class="card">
        <span class="ico-badge ico-badge--sm"><svg class="ico"><use href="#i-shield"/></svg></span>
        <h3 class="card__t">{{ $t("权限与协作") }}</h3>
        <p class="card__d">{{ $t("谁能看什么，按角色分好，不用共享一个账号。") }}</p>
        <ul class="card__list"><li>{{ $t("客服 / 运营 / 老板三档") }}</li><li>{{ $t("操作日志可追溯") }}</li></ul>
      </article>
    </div>
  </div>
</section>

<!-- ============ CTA ============ -->

<section class="sec sec--tight">
  <div class="wrap">
    <div class="pandy">
      <img class="pandy__m" src="/website/img/tao-hi.png" alt="">
      <div>
        <p class="pandy__t">{{ $t("这一页东西多，不用全看完") }}</p>
        <p class="pandy__b">{{ $t("你只要记住一句：") }}<b>{{ $t("开店要用的六件事，这里都有对应的人") }}</b>{{ $t("。建站、翻译、上架、发货、收款、拉客户——缺哪一块，直接跳到那一块看。") }}</p>
<router-link class="pandy__link" to="/pricing">{{ $t("先看要花多少钱") }} →</router-link>
      </div>
    </div>
  </div>
</section>

<section class="sec sec--tight">
  <div class="wrap">
    <div class="cta">
      <div>
        <h2 class="cta__t">{{ $t("看完了，直接开一间试试") }}</h2>
        <p class="cta__d">{{ $t("免费开店，不绑卡、不签合同。店铺先跑起来，觉得有用再谈套餐。") }}</p>
      </div>
      <div class="cta__btns">
        <router-link class="btn btn--primary" to="/sign-up">{{ $t("免费开店") }}</router-link>
        <router-link class="btn btn--ghost" to="/pricing">{{ $t("看价格") }}</router-link>
      </div>
    </div>
  </div>
</section>

</main>
</template>

<script>
export default {
  name: 'WebsiteFeatures',
}
</script>
